import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { Select } from '@ngxs/store';
import { AppFontSize } from 'src/app/enums/app-font-size.enum';
import { AppSettingsState } from 'src/states';
import { Observable } from 'rxjs';
import { AsyncPipe } from '@angular/common';
import { FontSizeControlsComponent } from '../font-size-controls/font-size-controls.component';

@Component({
  selector: 'app-font-size-controls-container',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './font-size-controls-container.component.html',
  imports: [FontSizeControlsComponent, AsyncPipe]
})
export class FontSizeControlsContainerComponent {
  @Select(AppSettingsState.fontSize)
  public readonly fontSize$!: Observable<AppFontSize>;

  public readonly isCollapsible = input(false);
}
